import React from 'react';
import { GiWheat, GiFarmTractor, GiScythe } from 'react-icons/gi';
import { MdAgriculture, MdPrecisionManufacturing } from 'react-icons/md';
import { TbEngine } from 'react-icons/tb';
import { FaWrench } from 'react-icons/fa';
import '../../../../assets/css/user/home/subscreens/banner/Banner.css';

const Banner = () => {
  const bannerItems = [
    { text: 'TRACTOR RENTAL',    icon: GiFarmTractor },
    { text: 'HARVESTER',         icon: GiWheat },
    { text: 'AGRI MACHINERY',    icon: MdAgriculture },
    { text: 'MAINTENANCE',       icon: FaWrench },
    { text: 'ROTAVATOR',         icon: GiFarmTractor }, // fixed
    { text: 'PRECISION FARMING', icon: MdPrecisionManufacturing },
    { text: 'COMBINE',           icon: GiScythe },
    { text: 'ENGINE REPAIR',     icon: TbEngine },
  ];

  return (
    <div className="scrolling-banner-wrapper">
      <div className="scrolling-banner">
        <div className="scrolling-content">
          {bannerItems.map((item, index) => (
            <div key={`first-${index}`} className="banner-item">
              <item.icon className="banner-icon" />
              <span className="banner-text">{item.text}</span>
              <span className="banner-dot" />
            </div>
          ))}
          {bannerItems.map((item, index) => (
            <div key={`second-${index}`} className="banner-item">
              <item.icon className="banner-icon" />
              <span className="banner-text">{item.text}</span>
              <span className="banner-dot" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;